var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Accordion as IngredientsAccordion, AccordionItem, } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Accordion';
import classNames from 'classnames';
import CmsComponentGrid from '../../components/CmsComponentGrid';
import { ACCORDION } from '../../constants/cmsResourceTypes';
const Accordion = (_a) => {
    var { componentId, accordionTitle, breakpointClasses, anchorId, openAccordion } = _a, rest = __rest(_a, ["componentId", "accordionTitle", "breakpointClasses", "anchorId", "openAccordion"]);
    return (React.createElement("section", { className: classNames(breakpointClasses) },
        React.createElement(IngredientsAccordion, { id: anchorId },
            React.createElement(AccordionItem, { id: componentId, title: accordionTitle !== null && accordionTitle !== void 0 ? accordionTitle : '', defaultExpanded: openAccordion },
                React.createElement(CmsComponentGrid, Object.assign({}, rest))))));
};
Accordion.resourceType = ACCORDION;
export default Accordion;
//# sourceMappingURL=index.js.map